<script setup>
import { usePrintTemplates } from '@/composables/print-template'

import PrintTemplateThumbnail from '@/components/accounting/PrintTemplateThumbnail.vue'

defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  templateFor: {
    type: Function,
    required: true,
  },
  documentType: {
    type: Number,
    required: false,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue'])

const { layouts } = usePrintTemplates()
</script>
<template>
  <div class="print-layout-picker">
    <button
      v-for="layout in layouts"
      :key="layout.id"
      type="button"
      class="print-layout-picker-item column items-center"
      :class="{ selected: modelValue === layout.id }"
      @click="emit('update:modelValue', layout.id)"
    >
      <print-template-thumbnail :template="templateFor(layout.id)" :document-type="documentType" />
      <span>{{ layout.name }}</span>
    </button>
  </div>
</template>
<style scoped lang="scss">
.print-layout-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(4.5rem, 1fr));
  gap: .5rem;
}

.print-layout-picker-item {
  gap: .25rem;
  padding: .25rem;
  border: .125rem solid transparent;
  border-radius: .375rem;
  background-color: $grey-2;
  font-size: .6875rem;
  cursor: pointer;

  &.selected {
    border-color: $primary;
    color: $primary;
    font-weight: 500;
  }
}
</style>
